export enum TeacherFormField {
  UrlSlug = "UrlSlug",
}
